// extracted by mini-css-extract-plugin
var _1 = "SlackMessage-module__animateUploadProgressBarWidth--ylUpG";
var _2 = "SlackMessage-module__animatedBackground--JQFf3";
var _3 = "SlackMessage-module__avatar--K9Uvj";
var _4 = "SlackMessage-module__content--A8OiM";
var _5 = "SlackMessage-module__edited--IpwwC";
var _6 = "SlackMessage-module__header--vB3fk";
var _7 = "SlackMessage-module__message--eldyb";
var _8 = "SlackMessage-module__timestamp--x5f6u";
var _9 = "SlackMessage-module__user--xj9v5";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatar", _4 as "content", _5 as "edited", _6 as "header", _7 as "message", _8 as "timestamp", _9 as "user" }
